import { render, staticRenderFns } from "./AiChatHistoryTable.vue?vue&type=template&id=37c80723&"
import script from "./AiChatHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AiChatHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports